<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file teamListItem.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  teamListItem.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: teamListItem 
 Created by keni.
 with: IntelliJ IDEA
 Date: 04/06/2018
 Time: 14:31
------------------------------------------------------------------------------->
<template>
    <section>
        <div>
            <ul class="nav nav-tabs nav-justified" role="tablist">
                <li
                        v-for="(teams,index) in teams_sorted"
                        class="nav-item"
                >
                    <div class="nav-link"
                         data-vue-toggle="tab"
                         v-on:click="toggleTab(index)"
                         role="tab"
                         :href="'#panel_' + index"
                         :class="{'active': selected_category === index}"
                    >
                        <!--<i class="fa fa-user"></i>-->
                        <div class="cursor-pointer d-flex justify-content-center align-items-center">
                            <i data-v-01a964ad="" class="fa fs-15 mr-1"
                               :class="'icon-category-'+index"></i>
                            <span class="font-weight-normal text-uppercase"

                            >{{index}}</span>
                        </div>

                    </div>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div :id="'panel_' + index"
                 v-for="(category_team,index) in teams_sorted"
                 class="tab-pane fade in"
                 :class="{
                    'show active':selected_category === index
                    }"
                 role="tabpanel"
            >
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <paginate
                                    class="mb-3"
                                    :element_classes="{
                                        select:{
                                            label:'',
                                            element:'',
                                            element_option:'',
                                            class:'d-none'
                                        },
                                        button:{
                                            previous:'pl-2 pr-2 ml-2',
                                            next:'pl-2 pr-2',
                                            class:''
                                        },
                                        index:' ml-2'
                                    }"
                                    :page_id="pagination.elements[index].id"
                                    :page_start="pagination.elements[index].start"
                                    :page_end="pagination.elements[index].end"
                                    :page_limit="pagination.elements[index].limit"
                                    :pages_length="category_teams[index].length"
                                    :select_options="pagination.rowsPerPageList"
                                    :callback_name="pagination.elements[index].callback_name"
                                    :callback_data="pagination.elements[index].callback_data"
                                    position="start"
                                    @pageinate_event="paginatePage"
                            ></paginate>
                        </div>
                    </div>
                    <div class="row">
                        <!--v-for="team,category_index in limitTeams(category_team)"-->
                        <div class="col-6 col-md-3 my-5"
                             style="max-height: 300px"
                             v-for="(team,category_index) in teams_sorted[index]"
                        >
                            <a :href="createLink(index,team)"
                               class="card-outline-0 card hoverable z-depth-1">
                                <figure class="card__img">
                                    <img v-if="show_images"
                                         :alt="lang('title',team.team_data.lang)"
                                         style="width: 100%;max-height:200px"
                                         class="image-preload"
                                         :data-image="readTeamImage(team)"
                                         :src="readTeamImage(team)"
                                         @error="onImageError"
                                    >
                                </figure>
                                <div class="card__desc">
                                    <h5 class="text-center text-body">
                                        <bold-words :word="{
                text:lang('title',team.team_data.lang)
                }"
                                        />
                                    </h5>
                                </div>
                            </a>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <paginate
                                    class="mb-3"
                                    :element_classes="{
                                        select:{
                                            label:'',
                                            element:'',
                                            element_option:'',
                                            class:'d-none'
                                        },
                                        button:{
                                            previous:'pl-2 pr-2 ml-2',
                                            next:'pl-2 pr-2',
                                            class:''
                                        },
                                        index:' ml-2'
                                    }"
                                    :page_id="pagination.elements[index].id"
                                    :page_start="pagination.elements[index].start"
                                    :page_end="pagination.elements[index].end"
                                    :page_limit="pagination.elements[index].limit"
                                    :pages_length="category_teams[index].length"
                                    :select_options="pagination.rowsPerPageList"
                                    :callback_name="pagination.elements[index].callback_name"
                                    :callback_data="pagination.elements[index].callback_data"
                                    position="start"
                                    @pageinate_event="paginatePage"
                            ></paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import {_} from 'underscore';
    import lang from '../../../../../app/Shared/Resources/Assets/js/helpers/lang';
    import {readTeamImage} from '../../../../../app/Shared/Resources/Assets/js/helpers/images';
    import {uniqueId} from '../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';

    Vue.component('bold-words', require('../../../../../app/Shared/Resources/Assets/js/components/BoldWords'));
    Vue.component('paginate', require('../../../../../app/Shared/Resources/Assets/js/components/Pagination.vue'));

    export default {
        name: "team-list-item",
        components: {},
        props: {
            team_request_url: String,
            team_image_base_url: String,
            default_team_image_url: String,
        },

        computed: {

            // A computed property that holds only those articles that match the searchString.
            filteredArticles: function () {
                // let self = this,
                //     articles_array = self.category_teams[],
                // 	searchString = this.searchString;
                //
                //
                // if(!searchString){
                // 	return articles_array;
                // }
                //
                // searchString = searchString.trim().toLowerCase();
                //
                // articles_array = articles_array.filter(function(item){
                // 	if(item.title.toLowerCase().indexOf(searchString) !== -1){
                // 		return item;
                // 	}
                // })
                //
                // // Return an array with the filtered data.
                // return articles_array;;
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            this.readTeams();
        },
        data() {
            return {
                show_images: true,
                selected_category: '',
                searchString: "",
                tab_panels: {},
                /**
                 * @property category_teams.category_team.team
                 * @property category_teams.category_team.team_data
                 * @property category_teams.category_team.category_index
                 * @property category_teams.category_team
                 * @namespace
                 */
                category_teams: Array,
                team_categories: Array,
                teams_sorted: {},
                page_points: {
                    start: 0,
                    end: 12
                },
                page_limit: 12,
                pagination: {
                    elements: {},
                    // callback_name: 'pageinate_event',
                    // numberOfPages: 0,
                    // limit: 10,
                    // start: 0,
                    // end: 50,
                    rowsPerPageList: [10, 20]
                },

            }
        },
        methods: {
            isCurrent(index) {
                return (index == this.selected_category);
            },
            toggleTab(index) {
                this.selected_category = index;
                // console.log('index',index,$('#panel_'+index));
                // $('#panel_'+index).tab('show');
            },
            createLink(category, team) {
                return '/' + category + '/teams/' + team.slug;
            },
            paginatePage(data) {
                let pageElement = '';
                if (!data.records) {

                } else {
                    pageElement = data.records.name;
                }
                /**
                 * set the number of rows to be sown in the list
                 */
                if (data.action == 'rows') {
                    this.pagination.elements[pageElement].limit = data.value;
                }
                /**
                 * calculate the starting index of the paginated result
                 */
                if (data.action == 'next') {
                    console.log('this.pagination.elements[pageElement].start', this.pagination.elements[pageElement].start);

                    if (data.value == true) {
                        this.pagination.elements[pageElement].start = this.pagination.elements[pageElement].start + this.pagination.elements[pageElement].limit;
                        this.pagination.elements[pageElement].end = this.pagination.elements[pageElement].start + this.pagination.elements[pageElement].limit;
                    } else {
                        this.pagination.elements[pageElement].start = this.pagination.elements[pageElement].start - this.pagination.elements[pageElement].limit;
                    }

                    // if (this.pagination.start >= this.records.length) {
                    // 	// get the remaining left overs
                    // 	console.log(origStart, 'next limited', this.pagination.start);
                    //
                    // 	this.pagination.start = origStart;
                    // 	console.log('result', this.pagination.start);
                    // }
                    if (this.pagination.elements[pageElement].start < 0) {
                        this.pagination.elements[pageElement].start = 0;
                        // console.log('prev limited');

                    }
                    console.log('this.pagination.elements[pageElement]', this.pagination.elements[pageElement]);
                }

                this.teams_sorted[pageElement] = this.setPaginationEnd(this.category_teams[pageElement], pageElement);
            },
            log(...args) {
                // console.log.apply(console, Array.prototype.slice.call(arguments));
                console.log(args);
            },
            lang(path, object) {
                return lang(path, object)
            },
            getFirst() {
                let props = Object.keys(this.category_teams);
                return _.first(props);
            },
            isFirst(item) {
                // console.log('props', props, 'first', first, this.category_teams);

                return this.getFirst(props) == item;
            },
            onImageError(e) {
                e.target.src = this.default_team_image_url;
            },
            readTeamImage(team) {

                // console.log('readTeamImage(team.team_data, this.team_image_base_url, this.default_team_image_url)',readTeamImage(team.team_data, this.team_image_base_url, this.default_team_image_url));
                return readTeamImage(team.team_data, this.team_image_base_url);
            },
            readTeams() {
                let _this = this,
                    data = {};

                axios.post(this.team_request_url, data)
                    .then(function (response) {
                        if (response.data.success) {
                            _this.category_teams = response.data.teams;
                            console.log('_this.category_teams', _this.category_teams);

                            _this.team_categories = _.keys(_this.category_teams);
                            _this.selected_category = _this.getFirst();

                            /**
                             * Build the categories for menu
                             */
                            for (let i = 0; i < _this.team_categories.length; i++) {
                                let element = _this.team_categories[i];
                                _this.pagination.elements[element] = {
                                    id: uniqueId(),
                                    callback_name: 'pageinate_event',
                                    callback_data: {name: element},
                                    numberOfPages: 0,
                                    limit: _this.page_limit,
                                    start: 0,
                                    end: _this.page_limit,
                                    rowsPerPageList: [10, 20]
                                };

                                _this.createTeamList(element, response.data.teams[element]);

                                // console.log('argument', argument);

                            }

                        }
                    })
                    .catch(function () {

                    });
            },
            createTeamList(element, data) {
                let _this = this;

                if (!(typeof this.teams_sorted[element] !== 'undefined' && this.teams_sorted[element] !== null)) {
                    _this.$set(this.teams_sorted, element, 'test');
                }
                this.teams_sorted[element] = _this.setPaginationEnd(data, element);
                // console.log('this.teams_sorted', this.teams_sorted);
            },
            setPaginationEnd(records, index) {
                this.pagination.elements[index].start = (typeof this.pagination.elements[index] !== 'undefined' && this.pagination.elements[index] !== null)
                                                        ? this.pagination.elements[index].start
                                                        : 0;

                this.pagination.elements[index].end = records.length;
                let
                    startCondition = this.pagination.elements[index].start + this.pagination.elements[index].limit;

                if (startCondition > records.length) {
                    this.pagination.elements[index].start = records.length - this.pagination.elements[index].limit;

                } else {
                    // console.log('down');
                    this.pagination.elements[index].end = this.pagination.elements[index].start + this.pagination.elements[index].limit;
                }
                // console.log('start', this.pagination.elements[index].start, 'end', this.pagination.elements[index].end);
                return records.slice(this.pagination.elements[index].start, this.pagination.elements[index].end);
            },
        },
        watch: {},
    }
</script>

<style scoped>
    .card__img {
        margin: -20px -20px 0;
    }

    img {
        max-width: 100%;
        height: auto;
        border: 0;
        vertical-align: middle;
        box-sizing: border-box;
    }

    .card__desc {
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/teams/teamListItem.vue